import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import { Cite } from "@/components/Cite";

const PROFILES = [
  ["Hai una vita piena", "Lavoro, famiglia, impegni: il tempo per te è poco e frammentato. Non ti serve una scheda in più, ti serve un sistema che stia dentro la tua settimana reale."],
  ["Hai iniziato e mollato più volte", "Diete, abbonamenti, programmi: parti forte e dopo qualche settimana ti fermi. Sai già cosa fare, il problema è continuare a farlo."],
  ["Il cibo è anche una valvola", "Stress, noia o stanchezza ti portano a mangiare senza fame. Vuoi capire cosa c'è dietro, non contare calorie per sempre.", ["adam2007", "tomiyama2011"]],
  ["Ragioni in «tutto o niente»", "Se salti un allenamento la settimana è persa, se sgarri un pasto tanto vale lasciar perdere. Vuoi costanza, non perfezione.", ["westenhoefer1999", "lally2010"]],
  ["Vuoi ricomporre, non solo dimagrire", "Il numero sulla bilancia non ti basta: vuoi meno grasso, più muscolo, più energia, e un corpo che resti così nel tempo."],
  ["Vuoi capire cosa stai facendo", "Preferisci le evidenze scientifiche alle mode del momento e vuoi diventare autonomo, non dipendente da un trainer per sempre."],
];

const NOT_FOR = [
  "Cerchi una dieta lampo o risultati in 30 giorni.",
  "Vuoi solo una scheda da seguire senza metterti in discussione.",
  "Non sei disposto a lavorare anche su abitudini, organizzazione ed emozioni.",
];

export const ForWho = () => (
  <div data-testid="for-who" className="mt-24">
    <div className="mb-10 grid gap-6 md:grid-cols-2 md:items-end">
      <div>
        <p className="eyebrow mb-4">Per chi è</p>
        <h3 className="font-display text-5xl font-900 uppercase leading-[0.88] md:text-6xl">
          Per chi sa già cosa fare, <span className="text-[#c4dcca]">ma non riesce a farlo nel tempo.</span>
        </h3>
      </div>
      <p className="max-w-md text-[#a3b1aa] md:justify-self-end">
        Il Lifestyle Training è pensato per adulti che vogliono una ricomposizione corporea sostenibile e hanno capito che il problema non è la scheda, ma tutto quello che le sta intorno.
      </p>
    </div>
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {PROFILES.map(([title, text, refs], i) => (
        <motion.div key={title} data-testid={`for-who-${i}`} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.7, delay: (i % 3) * 0.08 }}
          className="border border-[rgba(152,191,162,0.2)] bg-[#0b120e] p-6">
          <div className="flex items-center gap-3">
            <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-[#98bfa2] text-[#050807]"><Check size={15} /></span>
            <h4 className="font-display text-2xl font-900 uppercase leading-none">{title}</h4>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-[#a3b1aa]">{text}<Cite refs={refs} /></p>
        </motion.div>
      ))}
    </div>
    <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true, amount: 0.15 }}
      data-testid="not-for" className="mt-4 border border-[rgba(240,167,143,0.3)] p-6 md:flex md:items-start md:gap-10">
      <p className="eyebrow mb-4 shrink-0 !text-[#f0a78f] md:mb-0 md:pt-1">Non è per te se</p>
      <ul className="grid gap-3 md:grid-cols-3">
        {NOT_FOR.map((t) => (
          <li key={t} className="flex gap-3 text-sm text-[#a3b1aa]"><X size={16} className="mt-0.5 shrink-0 text-[#f0a78f]" />{t}</li>
        ))}
      </ul>
    </motion.div>
  </div>
);
